import { hideLoading, showLoading } from 'redux-store/reducers/loading-reducer';
import { danger } from 'redux-store/reducers/common-reducer';

import { API, patch } from 'utils/api';
import { logError } from 'utils/log';
import { __t, applyTranslations } from 'utils/language';
import { API_CODE_FB_DATA_ENABLING_NOT_SUPPORTED } from 'utils/status';

applyTranslations(require('../instagram-data-enabled.i18n.json'));

import type { Dispatch, ThunkAction } from 'types';

const { INFLUENCERS } = API.END_POINTS;
const MSG_KEY = 'instagram_data_enabled';

export const toggleDataEnabled = (
  offerId: number,
  deliverableId: number,
  dataEnabled: boolean
): ThunkAction => (
  async (dispatch: Dispatch) => {
    const url = INFLUENCERS.facebookToggleDataEnabled(offerId, deliverableId);

    try {
      dispatch(showLoading(url));

      await patch(url, {
        data: {
          fbEnabled: dataEnabled
        }
      }, { suppressGlobalNotification: true });

      dispatch(hideLoading(url));

      return true;
    } catch (error) {
      const isCodeMatch = error?.response?.data?.code === API_CODE_FB_DATA_ENABLING_NOT_SUPPORTED;
      const taskIdMsg = `${__t(`${MSG_KEY}.task_id`)}: ${deliverableId}`;
      const message = isCodeMatch
        ? `${__t(`${MSG_KEY}.errors.data_enable_not_supported`)}. ${taskIdMsg}`
        : `${__t(`${MSG_KEY}.errors.unable_to_toggle_type`)} ${taskIdMsg}`;

      logError(error);

      dispatch(hideLoading(url));
      dispatch(danger(message));

      return false;
    }
  }
);
